import React, {useState, Fragment, useEffect} from 'react';
import axios from 'axios';
import styles from  './hpi.module.scss'; 
import { getNumberWithOrdinalWithSuperscript } from '../../utils/utils';
import CountryFlag from '../common/countryFlag-openness/country-flag-openness';
import { listAfricaCities } from "../../data/data-list-africa-cities";
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';
import LoadingSpinner from '../common/loading/LoadingSpinner';


const options = [
    {label:"Global visa-free access (out of 226 destinations)", value:"hpi_dest"},
    {label:"Rank in Africa", value:"rank"},
    {label:"Visa-free travel (% of the world)", value:"hpi_rank"},
];



const HPI = () =>{
    const [data, setData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [sortColumn, setSortColumn] = useState("hpi_rank");
    const [tableSelectedStatus, setTableSelectedStatus] = useState(false);
    const [tableCodeSelected, setTableCodeSelected] = useState('');
    const [loading, setLoading] = useState(true);
    const [rankCount, setRankCount] = useState(1);
    const [hpidestCount, setHpidestCount] = useState(1);
    const [hpirankCount, setHpirankCount] = useState(1);
    let rank = 1;
    let setOfScore = [];
    // const linkPath = process.env.REACT_APP_HENLEY_API_PASSPORTINDEX_PATH;

    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get(process.env.REACT_APP_HENLEY_API_PASSPORTINDEX_PATH);
            
            const africaCities = response.data.filter(c => listAfricaCities.includes(c.name));
            setData(africaCities);
            setTableData(africaCities);
            setLoading(false);

          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
    
        fetchData();
    }, []);


    const tableRowData = (item, index) =>{
      
        item.hpi_dest = item.hpi_rank;
        
        setOfScore = [...new Set(data.map(c => c.hpi_score))].sort((a, b) => b - a);
        rank  = setOfScore.indexOf(item.hpi_score) + 1;
        item.rank = rank;

        if (rank > 20) {
          return null;
        }
        
        return (
            <Fragment key={index}>
              <tr className={`${styles.contentRow} ${item.code === tableCodeSelected ? styles.selectedRow : ''}
              `}>

                  <td className={styles.mobileLeftColumn}>
                      <div className="d-flex align-items-center">
                         
                          {/* <CountryFlag country={item.name} code={item.code}/> */}
                          <CountryFlag iso={item.code} country={item.name} />

                      </div>
                  </td>
                  <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'rank'? styles.selectedColumn: ''}`}>
                      {getNumberWithOrdinalWithSuperscript(item.rank)}
                  </td>
                  <td 
                    className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'hpi_dest'? styles.selectedColumn: ''}`}
                  >
                    {item.hpi_score} 
                  </td> 
                  <td className={`text-right ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'hpi_rank'? styles.selectedColumn: ''}`}>
                      <span className="ms-2">{Math.round(item.hpi_score / 226 * 100) + '%'}</span>
                  </td>
      
              </tr>
            </Fragment>
        )
    }
    
    const reverseSortNum = (data, columnName, count) => {
      if (count === -1) {
        return data.sort((a, b) => b[columnName] - a[columnName] || (a.name.toUpperCase()).localeCompare(b.name.toUpperCase()));
      }
      return data.sort((a, b) => a[columnName] - b[columnName] || (a.name.toUpperCase()).localeCompare(b.name.toUpperCase()));
    }
    
    const sortTableData = (data, sortColumn) =>{
        switch (sortColumn) {
          case 'rank':
            return reverseSortNum(data, sortColumn, rankCount);
          case 'hpi_dest':
            return reverseSortNum(data, sortColumn, hpidestCount);
          case 'hpi_rank':
            return reverseSortNum(data, sortColumn, hpirankCount);
          default:
            break;
        }
    }
 


    const handleOptionSelect = (option) => {
        // setSelectedOption(option);
        setSortColumn(option.value);
    };

    const handleSort = (columnName) => {
      switch (columnName) {
        case 'rank':
          (rankCount === 1) ? setRankCount(-1) : setRankCount(1);
        case 'hpi_dest':
          (hpidestCount === 1) ? setHpidestCount(-1) : setHpidestCount(1);
          break;
        case 'hpi_rank':
          (hpirankCount === 1) ? setHpirankCount(-1) : setHpirankCount(1);
          break;
        default:
          break;
      }
      
        setSortColumn(columnName);
    };
    
    
    if (loading) return <LoadingSpinner />;

    // const slicedData = tableData.sort((a, b) => b.hpi_score - a.hpi_score || (a.name.toUpperCase()).localeCompare(b.name.toUpperCase())).filter((a) => a.rank < 21);
    const slicedData = tableData.sort((a, b) => b.hpi_score - a.hpi_score || (a.name.toUpperCase()).localeCompare(b.name.toUpperCase()));
    
    return( 
        <>  
            {/* <h3 className="mb-5">Africa's Top 20 Passports on the Henley Passport Index</h3> */}
            
            <div className={`d-md-none ${styles.sortMobileWrapper}`}>
                <div className={styles.sortTitle}>Sort by</div>
                <SelectDropdown options={options} onSelect={handleOptionSelect} />
            </div>
  

            <div className={styles.tableWrapper}>
                <table className={`chartTable  ${styles.overviewChartTable} ${tableSelectedStatus === true ? styles.dataTableOnSelected :''}`}>
                    <thead>
                        <tr>

                            <th className={styles.cityColumn} >Country</th>

                            <th
                              className={
                                `text-left 
                                              ${styles.cellHideMobile}
                                              ${styles.sortableColumn} 
                                              ${sortColumn === 'rank'? styles.selectedColumn: ''}
                                              ${sortColumn === 'rank' ? styles.displayColumnTitleDiv : ''}
                              `}
                              onClick={() => handleSort("rank")}
                            >
                              <div className={styles.sortColumnTitle}>
                                <span className={styles.sortColumnTitleText}>Rank in Africa</span>
                                {(rankCount === 1) ? <IconSort /> : <ReverseIconSort />}
                              </div>
                            </th>
                            
                    
                             <th 
                                className={`text-right ${styles.cellHideMobile}  ${styles.sortableColumn} 
                                                      ${sortColumn === 'hpi_dest'? styles.selectedColumn: ''}
                                                      ${sortColumn === 'hpi_dest' ? styles.displayColumnTitleDiv : ''}`}
                                onClick={() => handleSort("hpi_dest")}
                            >
                              <div className={styles.sortColumnTitle}>
                                <span className={styles.sortColumnTitleText}>Global visa-free access<br/>(out of 226 destinations)</span>
                                {(hpidestCount === 1) ? <IconSort /> : <ReverseIconSort />}
                              </div>
                            </th>
                            <th 
                                className={`text-right ${styles.cellHideMobile}  ${styles.sortableColumn} 
                                                      ${sortColumn === 'hpi_rank'? styles.selectedColumn: ''}
                                                      ${sortColumn === 'hpi_rank' ? styles.displayColumnTitleDiv : ''}`}
                                onClick={() => handleSort("hpi_rank")}
                                // width="18%"
                            >   
                              <div className={styles.sortColumnTitle}>
                                <span>Visa-free travel<br/>(% of the world)</span>
                                {(hpirankCount === 1) ? <IconSort /> : <ReverseIconSort />}
                              </div>
                            </th>
                            
                        </tr>
                    </thead>

                    <tbody className={styles.mainDataBody}>
                        
                        {sortTableData(slicedData, sortColumn).map((item, index) => (
                            tableRowData(item, index)
                        ))}
                    </tbody>
     
                    
                </table>
                
                <div className="footer-note mt-5">
                  <p>Source: Henley Passport Index</p>
                </div>
            </div>
        </>
    )
}

export default HPI;